export default {"src":"/_next/static/media/youth-discount-group.601bbdc9.svg","height":252,"width":609};